import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CTAButton } from './ui/CTAButton';
import { StatesList } from './StatesList';
export function HowToStart() {
  return <section className="mb-16" data-id="element-45">
      <FadeIn data-id="element-46">
        <div className="bg-gray-50 rounded-2xl p-6 md:p-8 border border-gray-100" data-id="element-47">
          <h3 className="text-2xl font-bold text-center text-[#111] mb-6" data-id="element-48">
            Select Your State to Begin
          </h3>
          <StatesList data-id="element-49" />
        </div>
      </FadeIn>

      {/* Final CTA */}
      <FadeIn data-id="element-50">
        <div className="flex justify-center mt-12" data-id="element-51">
          <CTAButton data-id="element-52">Check Prices in My Area</CTAButton>
        </div>
      </FadeIn>
    </section>;
}